import { z } from 'zod';

const DayString = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

/**
 * `event_invite`: the traveler's invitation (or reminder) to confirm presence at a
 * "Grupos e eventos" event, or a notice about the flights of the invite (`flights_ready`,
 * `flights_refused`, and `purchases_open` when the organizer opens the purchases of a survey-mode
 * invite: no deadline semantics, the producer fills the fields from the invite). The mice service
 * publishes it as a system event; the
 * conversation localizes it (`_event_invite_vars`). Not strict: the conversation adds
 * `notificationDisplay` to the same metadata.
 */
export const EventInviteMetadataSchema = z.object({
  kind: z.enum(['invite', 'reminder', 'flights_ready', 'flights_refused', 'purchases_open']),
  eventId: z.string().min(1),
  eventName: z.string().min(1),
  /** First day of the event (`YYYY-MM-DD`). */
  startDate: DayString,
  /** Last day (`YYYY-MM-DD`); null for a one-day event. */
  endDate: DayString.nullable(),
  venueName: z.string().min(1).nullable(),
  /** Last day to confirm (`YYYY-MM-DD`). */
  deadline: DayString,
  travelerFirstName: z.string().min(1),
  companyName: z.string().min(1),
  organizerName: z.string().min(1),
  /** `flights_refused`: the flight(s) the traveler asked for, one per direction, e.g.
   *  "LA 3301 · 25/11 e LA 3300 · 27/11" (no price). Absent on any other kind and on a refusal
   *  recorded before the field: the copy falls back to the generic sentence. */
  requestedFlight: z.string().min(1).max(120).optional(),
  /** The invite has no grid row: the producer pins the channel, e-mail only. */
  preferredChannel: z.literal('email'),
});
export type EventInviteMetadata = z.infer<typeof EventInviteMetadataSchema>;
